export default import.meta.ROLLDOWN_FILE_URL_HJ9zpsQKAVY6q4TZj9w_SA